/*
 * @Author: your name
 * @Date: 2019-11-15 10:35:23
 * @LastEditTime: 2020-11-19 10:01:58
 * @LastEditors: wutt
 * @Description: In User Settings Edit
 * @FilePath: /DianZiDiTu/src/components/onlineMap/model/TdtUserJs.js
 */

import AxiosConfig from "../../../config/AxiosConfigJs.js";
import qs from 'qs';

export class TdtUser
{   
    constructor()
    {   
        this.id=null;
        this.name=null;
        this.status=null;
        this.username=null;
        this.password=null;
        this.alias = null; // 用户别名
        this.token = null; // token
    }
    

    verify(url,succeedCallback, errorCallback)
    {   
        AxiosConfig.userManagerSystem
            .post(url,qs.stringify(this))
            .then(function (response) {
                var responseResult = null;
                //判断是否有响应结果
                if (response) {
                    responseResult = response.data;
                }
                //如果请求成功就将结果通过回调函数反馈
                if (succeedCallback) {
                    succeedCallback(responseResult);
                }
            })
            .catch(function (error) {

                if (errorCallback) {
                    errorCallback(error);
                }
            });
    }


    static getsession(url, succeedCallback, errorCallback)
    {
        AxiosConfig.platform
            .get(url,{ params: { random: Math.random()} })
            .then(function (response) {
                var responseResult = null;
                if (response != null) {
                    responseResult = response.data;
                }
                if (succeedCallback) {
                    succeedCallback(responseResult);
                }
            })

            .catch(function (error) {
                if (errorCallback) {

                    errorCallback(error);
                }

            });
    }

    //将json串转化成对象
    static fromJson(jsonObject) {
        let user = null;
        //判断是否传参，为传参返回null
        if (!jsonObject) return user;
        
        user = new TdtUser();
        user.id = jsonObject.id;
        user.name = jsonObject.name;
        user.status=jsonObject.status;
        user.username=jsonObject.username;
        user.password = jsonObject.password;
        user.token=jsonObject.token;
        user.alias=jsonObject.alias;
        return user;
    }
}

TdtUser.currentUser=null;

TdtUser.envIsPublic=false;